import type { Project } from "../hooks/useProjects.ts";
import { formatNumber, formatDate } from "../lib/format.ts";

export function ProjectCard({ project, rank }: { project: Project; rank?: number }) {
  return (
    <a
      href={project.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group flex items-center gap-4 px-4 py-3 border-b border-border hover:bg-surface-hover transition-colors"
    >
      {rank !== undefined && (
        <span className="text-text-muted text-xs w-6 text-right shrink-0 tabular-nums">
          {rank}
        </span>
      )}

      {project.logo_url ? (
        <img
          src={project.logo_url}
          alt=""
          className="w-6 h-6 rounded shrink-0 grayscale group-hover:grayscale-0 transition-all"
          loading="lazy"
        />
      ) : (
        <span className="w-6 h-6 shrink-0" />
      )}

      <div className="min-w-0 flex-1 flex items-center gap-3">
        <span className="text-sm text-text-primary group-hover:text-accent transition-colors truncate shrink-0 max-w-[220px] font-medium">
          {project.full_name}
        </span>
        {project.description && (
          <span className="text-xs text-text-muted truncate min-w-0 hidden lg:inline">
            {project.description}
          </span>
        )}
      </div>

      <div className="flex items-center gap-4 shrink-0 text-xs text-text-secondary tabular-nums">
        <span className="hidden sm:inline w-16 text-text-muted truncate">
          {project.language || ""}
        </span>
        <span className="w-16 text-right" title="Stars">
          {formatNumber(project.stars)}
        </span>
        <span className="w-14 text-right text-text-muted hidden sm:inline" title="Forks">
          {formatNumber(project.forks)}
        </span>
        {project.updated_at_gh && (
          <span className="w-16 text-right text-text-muted hidden md:inline">
            {formatDate(project.updated_at_gh)}
          </span>
        )}
      </div>
    </a>
  );
}
